const CLOUD_ACCOUNT_ID = process.env.CLOUD_ACCOUNT_ID
const CLOUD_API_TOKEN = process.env.CLOUD_API_TOKEN

export namespace cloud {
    export namespace response {
        export type base = {
            errors: unknown
            messages: unknown
            result: unknown
            success: boolean
        }

        export type success = base & { success: true }
        export type error = base & {
            errors: Array<{
                code: number
                message: string
            }>
        }

        export type upload<B> = B & {
            result: {
                id: string
                uploadURL: string
            }
        }

        export type info<B> = B & {
            result: {
                filename: string
                id: string
                meta: unknown
                requireSignedURLs: boolean
                uploaded: string
                variants: string[]
                draft?: true
            }
        }

        export const isCloudInfo = (I: unknown): I is info<success> => (I as info<success>) && 'success' in (I as info<success>) && (I as info<success>).success == true
        export const isUploadIntent = (I: unknown): I is upload<success> => (I as info<success>) && 'success' in (I as upload<success>) && (I as upload<success>).success == true
        export const isSuccess = (I: unknown): I is success => (I as info<success>) && 'success' in (I as success) && (I as success).success == true
    }

    export const Delete = async (fileId: string) => {
        const delete_endpoint = `https://api.cloudflare.com/client/v4/accounts/${CLOUD_ACCOUNT_ID}/images/v1/${fileId}`
        const result: unknown = await fetch(delete_endpoint, {
            method: 'delete',
            headers: {
                Authorization: `Bearer ${CLOUD_API_TOKEN}`,
            },
        })
            .then((response) => response.json())
            .catch(() => null)

        if (response.isSuccess(result)) return result
        else return null
    }

    export const Info = async (fileId: string) => {
        const info_endpoint = `https://api.cloudflare.com/client/v4/accounts/${CLOUD_ACCOUNT_ID}/images/v1/${fileId}`
        const result: unknown = await fetch(info_endpoint, {
            method: 'get',
            headers: {
                Authorization: `Bearer ${CLOUD_API_TOKEN}`,
            },
        })
            .then((response) => response.json())
            .catch(() => null)

        if (response.isCloudInfo(result)) return result
        else return null
    }

    /** This is not direct upload. Метод инициализирует загрузку и возвращает из клауда одноразовый uri,
     *  куда пользователь отправит файл непосредственно из браузера.
     *  Это позволит нам увести убработку траффика из приложения. */
    export const Upload = async () => {
        const upload_endpoint = `https://api.cloudflare.com/client/v4/accounts/${CLOUD_ACCOUNT_ID}/images/v2/direct_upload`
        const intent: unknown = await fetch(upload_endpoint, {
            method: 'post',
            headers: {
                Authorization: `Bearer ${CLOUD_API_TOKEN}`,
            },
        }).then((response) => response.json())

        if (response.isUploadIntent(intent)) return intent
        else return null
    }

    export const AdminUpload = async (from) => {
        const formData = new FormData()
        formData.append('url', from)
        formData.append('requireSignedURLs', 'false')

        const upload_endpoint = `https://api.cloudflare.com/client/v4/accounts/${CLOUD_ACCOUNT_ID}/images/v1`
        const intent: unknown = await fetch(upload_endpoint, {
            method: 'post',
            headers: {
                Authorization: `Bearer ${CLOUD_API_TOKEN}`,
            },
            body: formData,
        }).then((response) => response.json())

        if (response.isUploadIntent(intent)) return intent
        else return null
    }
}
